var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"trigger",class:{
    'tippy--overflow-ellipsis': _vm.isOverflowEllipsis,
    'tippy--fullwidth': _vm.isFullwidth,
  }},[_vm._t("trigger")],2),_c('div',{ref:"content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }